import { createSelector } from 'reselect';

// Config
import { getAppShopsToShowSelector } from '@redux/reducers/app/appSelector';
import {
  getCollectionPointDetailsCallActiveSelector,
  getActiveModalMapMarkerSelector,
  getActiveViewTypeSelector,
  getClickAndCollectActiveMapMarkerSelector,
  getClickAndCollectCountdownVisibleSelector,
  getClickAndCollectCutOffTimeForAllStoresSelector,
  getClickAndCollectEarliestCollectionDateTimeSelector,
  getClickAndCollectSelectingCollectionPointIdSelector,
  getClickAndCollectStoreToPromoteSelector,
  getCollectionPointDatesApiCallActiveSelector,
  getCollectionPointSearchActiveSelector,
  getCollectionPointSearchCompleteSelector,
  getCollectionPointSearchResultsSelector,
  getCollectionPointSearchTermSelector,
  getCollectionPointsOwnersSelector,
  getFindCollectionPointErrorSelector,
  getIsFreeCollectionSelector,
  getModalShowSelectShopButtonSelector,
  getSavedCollectionPointsApiCallLoadingSelector,
  getSelectedCollectionPointSelector,
  getStoreDetailsModalOpenSelector,
  getTotalCollectionPointsSelector,
  getHideMapInStoreDetailsModalSelector,
} from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import { getShowSavedCollectionPointsModalSelector } from '@redux/reducers/delivery/deliverySelector';
import { getUserSavedCollectionPointsSelector } from '@redux/reducers/user/userSelector';

const clickAndCollectState = createSelector(
  [
    getCollectionPointSearchResultsSelector,
    getCollectionPointSearchTermSelector,
    getCollectionPointSearchActiveSelector,
    getCollectionPointSearchCompleteSelector,
    getFindCollectionPointErrorSelector,
    getStoreDetailsModalOpenSelector,
    getModalShowSelectShopButtonSelector,
    getSelectedCollectionPointSelector,
    getTotalCollectionPointsSelector,
    getShowSavedCollectionPointsModalSelector,
    getUserSavedCollectionPointsSelector,
    getActiveModalMapMarkerSelector,
    getCollectionPointDetailsCallActiveSelector,
    getCollectionPointDatesApiCallActiveSelector,
    getSavedCollectionPointsApiCallLoadingSelector,
    getActiveViewTypeSelector,
    getCollectionPointsOwnersSelector,
    getIsFreeCollectionSelector,
    getClickAndCollectActiveMapMarkerSelector,
    getClickAndCollectCountdownVisibleSelector,
    getClickAndCollectCutOffTimeForAllStoresSelector,
    getClickAndCollectEarliestCollectionDateTimeSelector,
    getAppShopsToShowSelector,
    getClickAndCollectSelectingCollectionPointIdSelector,
    getClickAndCollectStoreToPromoteSelector,
    getHideMapInStoreDetailsModalSelector,
  ],
  (
    collectionPointSearchResults,
    collectionPointSearchTerm,
    collectionPointSearchActive,
    collectionPointSearchComplete,
    findCollectionPointError,
    storeDetailsModalOpen,
    modalShowSelectShopButton,
    selectedCollectionPoint,
    totalCollectionPoints,
    showSavedCollectionPointsModal,
    savedCollectionPoints,
    activeModalMapMarker,
    getCollectionPointDetailsCallActive,
    getCollectionPointDatesApiCallActive,
    getSavedCollectionPointsApiCallLoading,
    activeViewType,
    collectionPointsOwners,
    isFreeCollection,
    activeMapMarker,
    countdownVisible,
    cutOffTimeForAllStores,
    earliestCollectionDateTime,
    shopsToShow,
    selectingCollectionPointId,
    storeToPromote,
    hideMapInStoreDetailsModal,
  ) => ({
    collectionPointSearchResults,
    collectionPointSearchTerm,
    collectionPointSearchActive,
    collectionPointSearchComplete,
    findCollectionPointError,
    storeDetailsModalOpen,
    modalShowSelectShopButton,
    selectedCollectionPoint,
    totalCollectionPoints,
    showSavedCollectionPointsModal,
    savedCollectionPoints,
    activeModalMapMarker,
    getCollectionPointDetailsCallActive,
    getCollectionPointDatesApiCallActive,
    getSavedCollectionPointsApiCallLoading,
    activeViewType,
    collectionPointsOwners,
    isFreeCollection,
    activeMapMarker,
    countdownVisible,
    cutOffTimeForAllStores,
    earliestCollectionDateTime,
    shopsToShow,
    selectingCollectionPointId,
    storeToPromote,
    hideMapInStoreDetailsModal,
  }),
);

export default clickAndCollectState;
